
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-dea80850\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SearchBox.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SearchBox.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-dea80850\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SearchBox.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBox.vue
// module id = 91
// module chunks = 0